<template>
<div ref="otpCont" data-component="CodeInput.vue">
	<input
		v-for="(el, index) in digits"
		:ref="'digit' + index"
		:key="el+index"
		v-model="digits[index]"
		type="text"
		inputmode="numeric"
		:autocomplete="index === 0 ? 'one-time-code' : ''"
		class="digit-box"
		:class="{ '!border-danger': error }"
		:autofocus="index === 0"
		maxlength="4"
		:disabled="disabled"
		@keydown="handleKeyDown($event, index)"
		@paste="handlePaste($event)"
		@input="handleInput($event, index)"
	>
</div>
</template>

<script>
export default {
	props: {
		digitCount: {
			type: Number,
			required: true,
		},
		autofocus: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
		},
		error: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['code-input-complete'],
	data() {
		return {
			digits: [],
		};
	},
	watch: {
		error(newVal) {
			if (newVal && newVal !== '') {
				this.clearFields();
				this.focusOnFirstInput();
			}
		},
	},
	created() {
		for (let i = 0; i < this.digitCount; i++) {
			this.digits[i] = null;
		}
	},
	mounted() {
		if (this.autofocus) {
			this.focusOnFirstInput();
		}
	},
	methods: {
		clear() {
			for (let i = 0; i < this.digitCount; i++) {
				this.digits[i] = null;
			}
			this.$emit('code-input-complete', '');
			if (this.focus) {
				(this.$refs.otpCont.children)[0].focus();
			}
		},
		handlePaste(event) {
			const code = event.clipboardData.getData('text');
			const codeArray = code.split('');
			if (code.length !== 4) {
				event.preventDefault();
			} else if (code.length === 4) {
				this.digits.forEach((el, index) => {
					this.digits[index] = codeArray[index];
				});
				this.$emit('code-input-complete', this.digits.join(''));
			}
		},
		isDigitsFull() {
			for (const elem of this.digits) {
				if (elem == null || elem === undefined) {
					return false;
				}
			}

			return true;
		},
		handleKeyDown(event, index) {
			if (event.ctrlKey) { return; }
			if (event.key !== 'Tab' && event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
				event.preventDefault();
			}

			if (event.key === 'Backspace') {
				this.digits[index] = null;

				if ((this.digits[index - 1] !== null && typeof this.digits[index + 1] !== 'undefined' && this.digits[index + 1] !== null)) {
					this.$nextTick(() => {
						const digitRef = this.$refs[`digit${index}`][0];
						digitRef.focus();
					});
					return;
				}

				if (index !== 0) {
					(this.$refs.otpCont.children)[index - 1].focus();
				} else {
					this.$nextTick(() => {
						(this.$refs.otpCont.children)[0].focus();
					});
				}

				return;
			}

			if ((new RegExp('^([0-9])$')).test(event.key)) {
				this.digits[index] = event.key;

				if (index !== this.digitCount - 1) {
					(this.$refs.otpCont.children[index + 1]).focus();
				}

				if (this.isDigitsFull()) {
					this.$emit('code-input-complete', this.digits.join(''));
				}
			}
		},
		handleInput(event) {
			const code = event.target.value;
			const codeArray = code.split('');
			if (code.length === this.digitCount) {
				this.digits.forEach((el, i) => {
					this.digits[i] = codeArray[i];
				});
				this.$emit('code-input-complete', this.digits.join(''));
			}
		},
		focusOnFirstInput() {
			this.$nextTick(() => {
				(this.$refs.otpCont.children)[0].focus();
			});
		},
		clearFields() {
			this.digits = [];
			for (let i = 0; i < this.digitCount; i++) {
				this.digits[i] = null;
			}
		},
	},
};
</script>

<style scoped>
.digit-box {
	width: 44px;
	padding: 0;
	margin: 5px;
	border-radius: 5px;
	font-size: 16px;
	text-align: center;
}
</style>
